import { Component, OnInit, ViewChild } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng/primeng';
import { ElencoPdvComponent } from './elenco-pdv/elenco-pdv.component';
import { ListCustomerValueComponent } from './list-customer-value/list-customer-value.component';
import { ShopOverviewMainKpiComponent } from './shop-overview-main-kpi/shop-overview-main-kpi.component';
import { ShopOverviewTrendComponent } from './trend/shop-overview-trend.component';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import {ApiMethods, PermissionConfiguration} from '../../../models/permission.model';
import { PermsService } from '../../../services/utils/perms.service';
import {Observable} from 'rxjs';
import { PanoramicaService } from './panoramica.service';

@Component({
  selector: 'app-panoramica',
  templateUrl: './panoramica.component.html',
  styleUrls: ['./panoramica.component.css']
})



// Pagina 20 - Pagina 21 - Pagina 23
export class PanoramicaComponent implements OnInit {
  @ViewChild(ElencoPdvComponent) shopElencoPdv: ElencoPdvComponent;
  @ViewChild(ListCustomerValueComponent) shopListCustomerValue: ListCustomerValueComponent;
  @ViewChild(ShopOverviewMainKpiComponent) shopMainKpi: ShopOverviewMainKpiComponent;
  @ViewChild(ShopOverviewTrendComponent) shopTrend: ShopOverviewTrendComponent;
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  oldData: any;

  activeIndex: number;
  translations: any;
  items: MenuItem[];


  /********************** PERMESSI UTENTE *************************/

  // Abilita tab KPI Principali
  public negoziPanoramicaOverviewPerm: boolean;
  public negoziPanoramicaOverviewPermCheck: PermissionConfiguration;

  // Abilita tab Elenco pdv
  public negoziPanoramicaElencoPerm: boolean;
  public negoziPanoramicaElencoPermCheck: PermissionConfiguration;

  // Abilita tab Trend
  public negoziPanoramicaTrendPerm: boolean;
  public negoziPanoramicaTrendPermCheck: PermissionConfiguration;

  // Abilita tab Valore Cliente
  public negoziPanoramicaClientePerm: boolean;
  public negoziPanoramicaClientePermCheck: PermissionConfiguration;

  /****************************************************************/



  constructor(private translate: TranslateService,
              private svcAnalytics: AnalyticsService,
              private srvPerms: PermsService,
              private panoramicService: PanoramicaService,
              private searchModelFactory: SearchToolbarModelFactoryService) {
    this.negoziPanoramicaOverviewPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-panoramica-overview',
      method: ApiMethods.GET
    };
    this.negoziPanoramicaElencoPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-panoramica-elenco',
      method: ApiMethods.GET
    };
    this.negoziPanoramicaTrendPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-panoramica-trend',
      method: ApiMethods.GET
    };
    this.negoziPanoramicaClientePermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'negozi-panoramica-cliente',
      method: ApiMethods.GET
    };
  }

  private loadScripts() {
    // You can load multiple scripts by just providing the key as argument into load method of the service
    this.panoramicService.load('google-maps').then(data => {
      // Script Loaded Successfully
      console.log("map loaded");
    }).catch(error => console.log(error));
  }

  ngOnInit() {
    this.loadScripts();
    const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
    searchParams.svcAnalytics = this.svcAnalytics;
    searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
    searchParams.finestra = SearchToolbarFilterWindow.Twenty;
    searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
    searchParams.disabledSections = [
      SearchToolbarSection.CardModes,
      // SearchToolbarSection.Stores --- FIXME T1817 EM: temporaneamente abilitato a causa di mancanza flag in filtro clienti
    ];
    this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
      this.searchModel = model;
    });

    this.activeIndex = 0;

    Observable.zip(
      this.srvPerms.check(this.negoziPanoramicaOverviewPermCheck),
      this.srvPerms.check(this.negoziPanoramicaElencoPermCheck),
      this.srvPerms.check(this.negoziPanoramicaTrendPermCheck),
      this.srvPerms.check(this.negoziPanoramicaClientePermCheck)
    ).subscribe (([negoziPanoramicaOverview, negoziPanoramicaElenco, negoziPanoramicaTrend, negoziPanoramicaCliente ]) => {
      console.log('PERMISSION');
      this.negoziPanoramicaOverviewPerm = negoziPanoramicaOverview ;
      this.negoziPanoramicaElencoPerm = negoziPanoramicaElenco ;
      this.negoziPanoramicaTrendPerm = negoziPanoramicaTrend ;
      this.negoziPanoramicaClientePerm = negoziPanoramicaCliente ;

      this.items = [];
        this.translate.get([
          'store.panoramica_title',
          'store.main_kpi',
          'store.trend',
          'store.elenco_pdv',
          'store.customerValueList'
        ]).subscribe(t => {
          this.items.push(
            {
              label: t['store.main_kpi'],
              command: (event: any) => {
                this.activeIndex = 0;
              }, disabled: !this.negoziPanoramicaOverviewPerm
            },
            {
              label: t['store.elenco_pdv'],
              command: (event: any) => {
                this.activeIndex = 1;
              }, disabled: !this.negoziPanoramicaElencoPerm
            },
            {
              label: t['store.trend'],
              command: (event: any) => {
                this.activeIndex = 2;
              }, disabled: !this.negoziPanoramicaTrendPerm
            },
            {
              label: t['store.customerValueList'],
              command: (event: any) => {
                this.activeIndex = 3;
              }, disabled: !this.negoziPanoramicaClientePerm
            }
          );

          for (let index in this.items) {
            if (!this.items[index].disabled) {
              this.activeIndex = +index;
              break;
            }
          }
        });
    });
  }

  ApplyResult (data) {
    const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

    switch (this.activeIndex) {
      case 0:
        if (!isDataEquals) {
          this.shopElencoPdv.resetData();
          this.shopTrend.resetData();
          this.shopListCustomerValue.resetData();
        }
        this.shopMainKpi.searchValue(data);
        break;
      case 1:
        if (!isDataEquals) {
          this.shopMainKpi.resetData();
          this.shopTrend.resetData();
          this.shopListCustomerValue.resetData();
        }

        this.shopElencoPdv.searchValue(data);
        break;
      case 2:
        if (!isDataEquals) {
          this.shopMainKpi.resetData();
          this.shopElencoPdv.resetData();
          this.shopListCustomerValue.resetData();
        }

        this.shopTrend.searchValue(data);
        break;
      case 3:
        if (!isDataEquals) {
          this.shopMainKpi.resetData();
          this.shopElencoPdv.resetData();
          this.shopTrend.resetData();
        }

        this.shopListCustomerValue.searchValue(data);
        break;
    }
    this.oldData = { ...data };
  }
}



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/panoramica.component.ts